import React, { useEffect } from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/css/bootstrap.css";
import "assets/scss/paper-dashboard.scss?v=1.3.0";
import "perfect-scrollbar/css/perfect-scrollbar.css";
import AdminLayout from "layouts/Admin.js";
import Login from "views/Auth/Login";
import AdminA from "./views/admin/AdminA";
import "./views/index.css";
import "assets/css/focus-mode.css"; // Add this line to import the focus mode CSS
import "assets/css/focus-mode-override.css"; // Add this line to import the focus mode override CSS
import "./utils/globalBeaconDebug"; // Add this line to import the global beacon debug utility
import "./utils/manualFocusFix"; // Add this line to import the manual focus fix utility
import Home from "views/client/Home";
import PostDetails from "views/Posts/PostDetails";
import InternDetails from "views/interns/InternshipDetails";
import ForgotPassword from "views/Auth/ForgotPassword";
import { Provider } from "react-redux";
import ApplicationForm from "views/client/ApplicationForm ";
import Profile from "views/client/profile";
import SavedPosts from "views/Posts/SavedPosts";
import PostsApplied from "views/Posts/PostsApplied";
import AddPost from "views/client/AddPost";
import ViewJob from "views/client/viewjob";
// import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import CreateRecruiter from "views/admin/createRecruiter";
import ListRecruiter from "views/admin/ListRecruiter";
import Settings from "views/Settings";
import useComponentZoom from "views/UseComponentZoom";
import ZoomableWrapper from "views/ZoomableWraper";
import ApplyJob from "views/client/ApplyJob";
import FormCustomizer from "views/Posts/FormCustomizer";
import ApplicationFormSp from "views/client/DynamicApplicationForm";
import NotFound from "components/PageNotFound/pageNotFound";
import ModernNotFound from "components/PageNotFound/pageNotFound";
import ApplicationsList from "views/user/ApplicationSpontaneeList";
import QuizList from "views/quiz/QuizList";
import QuizCreator from "views/quiz/QuizCreator";
import QuizResults from "views/quiz/QuizResults";
import QuizTaker from "views/quiz/QuizTaker";
import App from "views/Chat/Chat";
import VideoCallDisplay from "views/Chat/VideoCallInterface ";
import store from './store';
import PostDetailsScraped from "views/ScrapedPosts/PostDetailsScraped";
import { SnackbarProvider } from "components/snackBar/SnackbarProvider";
import { I18nextProvider } from "react-i18next";
import i18n from "./views/i18n";
import { PasswordResetConfirm } from "views/Auth/PasswordReset";
import { PasswordResetRequest } from "views/Auth/PasswordReset";
import { VideoCallProvider } from "store/VideoCallContext";
import { CallersIdProvider } from "store/callersIdContext";
import { SocketProvider } from "services/SocketContext";
import WebSocketManager from "components/WebSocketManager";
import WebSocketStatus from "components/WebSocketStatus";
import NotificationProvider from "context/NotificationContext";
import { TourProvider } from "context/TourContext";

// import LandingPage from "views/home/landingPage";
import OffersPage from "views/Offers/OffersPage";
import LandingPage from "views/Landing/landingPage";
import JobApplicationPage from "views/Offers/ApplicaionPage";
import NotificationsPage from "views/Notifications/Notifications";
import useUserId from "hooks/useUserId";
import RecruiterDashboard from "views/carnivals/recruiter/RecruiterDashboard";
import CandidateDashboard from "views/carnivals/candidate/CandidateDashboard";
import ViewResultCarnival from "views/carnivals/recruiter/ViewResultCarnival";
import InterviewRoomPage from "views/carnivals/candidate/InterviewRoomPage";
// import LandingPage from "views/home/landingPage";
import EmailTemplates from "views/Emailing/EmailTemplates";
import { SavedPostsProvider } from "views/Offers/hooks/useSavePost";
import SpontaneousPage from "views/Spontaneous offers/SpontaneousPage";
import SubscriptionConfirm from "views/Landing/SubscriptionConfirm";
import FastApplyPage from "views/Offers/FastApplyPage";
import ResumeForm from "views/client/resumeEditor/ResumeEditor";
import { useTour } from "context/TourContext";
import FocusModeDebugger from "components/Debug/FocusModeDebugger"; // Add this line
import Policies from "views/Candidates/policies";
import SuperAdminLayout from "views/SuperAdmin/SuperAdminLayout";
import NewPostDetails from "views/Posts/newPostDetails";
import CompanyRegistrationPage from "views/Auth/CompanyRegistrationPage";
import Blogs from "views/Candidates/Blogs";
import BlogArticle from "views/Candidates/BlogArticle";

const RouteProtector = ({ children, allowedRoles, redirectPath }) => {
  const user = useUserId();

  useEffect(() => {
    console.log("user is ::", user);
  }, [user]);

  const hasToken = !!localStorage.getItem("accessToken");

  // Public route: no restrictions
  if (!allowedRoles) {
    return children;
  }

  // If no token, definitely not logged in
  if (!hasToken) {
    return <Navigate to="/login" replace />;
  }

  // Token exists but hook hasn't decoded yet: wait (prevents redirect loops and token clearing)
  if (user.role == null || user.userId == null) {
    return null; // or a small loader
  }

  // Role not allowed
  if (allowedRoles && !allowedRoles.includes(user.role)) {
    return <Navigate to={redirectPath} replace />;
  }

  // All good
  return children;
};




const AppWrapper = () => {
  // const { startTour, startTourForRoute } = useTour();

  // // Auto-start tour for first-time visitors
  // useEffect(() => {
  //   const hasSeenDashboardTour = localStorage.getItem('tour_dashboard_completed');
    
  //   if (!hasSeenDashboardTour) {
  //     // Add a small delay to ensure all elements are rendered
  //     const timer = setTimeout(() => {
  //       startTourForRoute('/dashboard');
  //       localStorage.setItem('tour_dashboard_completed', 'true');
  //     }, 1000);
      
  //     return () => clearTimeout(timer);
  //   }
  // }, [startTourForRoute]);
  // Set the initial language when the app loads
  useEffect(() => {
    // Set French as default language
    const defaultLanguage = 'fr';
    
    // Check if there's a saved language preference
    const savedLanguage = localStorage.getItem("userLanguage");
    
    if (savedLanguage) {
      i18n.changeLanguage(savedLanguage);
    } else {
      // If no saved preference, use French as default
      i18n.changeLanguage(defaultLanguage);
      // Optionally save this preference
      localStorage.setItem("userLanguage", defaultLanguage);
    }
  }, []);

  return (
    <I18nextProvider i18n={i18n}>
      <Provider store={store}>
        <SocketProvider>
          <VideoCallProvider>
            <CallersIdProvider>
              <BrowserRouter>
                <TourProvider>
                  <NotificationProvider>
                    <SnackbarProvider>
                      <SavedPostsProvider>
                        {/* Global WebSocket manager for notifications */}
                        <WebSocketManager />
                        {/* WebSocket status indicator for debugging */}
                        <WebSocketStatus />
                        {/* <FocusModeDebugger /> Add this line */}
                        <Routes>
                          <Route
                            path="/talent"
                            element={
                              <RouteProtector
                                allowedRoles={["r"]}
                                redirectPath="/landing"
                              >
                                <AdminLayout />
                              </RouteProtector>
                            }
                          >
                            {/* Nested routes for /talent */}
                            <Route
                              index
                              element={<Navigate to="/talent/dashboard" replace />}
                            />
                            <Route
                              path="dashboard"
                              element={
                                <RouteProtector allowedRoles={["a"]}>
                                  <AdminA />
                                </RouteProtector>
                              }
                            />
                            <Route
                              path="form_customizer"
                              element={<FormCustomizer />}
                            />
                            <Route
                              path="createRecruiter"
                              element={<CreateRecruiter />}
                            />
                            <Route path="ListRecruiter" element={<ListRecruiter />} />
                            <Route path="settings" element={<Settings />} />
                            <Route path="create-quiz" element={<QuizCreator />} />
                            <Route path="take-quiz/:quizId" element={<QuizTaker />} />
                            <Route
                              path="quiz-results/:attemptId"
                              element={<QuizResults />}
                            />
                            <Route path="test" element={<RecruiterDashboard />} />
                            <Route
                              path="email-templates"
                              element={<EmailTemplates />}
                            />
                            <Route
                              path="post/:id"
                              element={
                                <RouteProtector
                                  allowedRoles={["r"]}
                                  redirectPath="/landing"
                                >
                                  <NewPostDetails />
                                </RouteProtector>
                              }
                            />
                            <Route
                              path="post/scraped/:id"
                              element={
                                <RouteProtector
                                  allowedRoles={["r"]}
                                  redirectPath="/landing"
                                >
                                  <NewPostDetails />
                                </RouteProtector>
                              }
                            />
                            <Route
                              path="posts/scraped/:id"
                              element={
                                <RouteProtector
                                  allowedRoles={["r"]}
                                  redirectPath="/landing"
                                >
                                  <NewPostDetails />
                                </RouteProtector>
                              }
                            />
                            <Route path="*" element={<ModernNotFound />} />
                          </Route>

                          <Route
                            path="/"
                            element={<Navigate to="/landing" replace />}
                          />
                          <Route
                            path="/carnivals/:carnivalId/results"
                            element={<ViewResultCarnival />}
                          />
                          <Route
                            path="/interview-room/:roomId"
                            element={<InterviewRoomPage />}
                          />

                          {/* Public routes - no authentication required */}
                          <Route path="/home" element={<LandingPage />} />
                          <Route path="/policies" element={<Policies />} />
                          <Route path="/landing" element={<LandingPage />} />
                          <Route path="/jobs" element={<OffersPage />} />
                          <Route path="/jobs/:jobId" element={<OffersPage />} />
                          <Route path="/spontaneous" element={<SpontaneousPage />} />
                          <Route path="/subscribe-confirm" element={<SubscriptionConfirm />} />
                          <Route path="/login" element={<Login />} />
                          <Route path="/company_register" element={<CompanyRegistrationPage />} />
                          <Route path="/application" element={<ApplicationForm />} />
                          <Route path="/blogs" element={<Blogs />} />
                          <Route path="/blog/:slug" element={<BlogArticle />} />
                          <Route path="/forgote_password" element={<ForgotPassword />} />
                          <Route path="/reset-password" element={<PasswordResetRequest />} />
                          <Route path="/reset-password/:uidb64/:token" element={<PasswordResetConfirm />} />

                          {/* Protected routes - require authentication */}
                          <Route
                            path="/chat"
                            element={
                              <RouteProtector
                                allowedRoles={["c", "r", "a"]}
                                redirectPath="/landing"
                              >
                                <App />
                              </RouteProtector>
                            }
                          />
                          <Route
                            path="/videoCall"
                            element={
                              <RouteProtector
                                allowedRoles={["c", "r", "a"]}
                                redirectPath="/landing"
                              >
                                <VideoCallDisplay />
                              </RouteProtector>
                            }
                          />
                          <Route
                            path="/application_page"
                            element={
                              <RouteProtector
                                allowedRoles={["c"]}
                                redirectPath="/landing"
                              >
                                <JobApplicationPage />
                              </RouteProtector>
                            }
                          />
                          <Route
                            path="/fast_application_page"
                            element={
                              // <RouteProtector
                              //   allowedRoles={["c"]}
                              //   redirectPath="/landing"
                              // >
                                <FastApplyPage />
                              // {/* </RouteProtector> */}
                            }
                          />
                          <Route
                            path="/resume_editor"
                            element={
                                <ResumeForm />
                            }
                          />
                          <Route
                            path="/notifications"
                            element={
                              <RouteProtector
                                allowedRoles={["c"]}
                                redirectPath="/landing"
                              >
                                <NotificationsPage />
                              </RouteProtector>
                            }
                          />
                          <Route
                            path="/profile"
                            element={
                              <RouteProtector
                                allowedRoles={["c"]}
                                redirectPath="/landing"
                              >
                                <Profile />
                              </RouteProtector>
                            }
                          />
                          <Route
                            path="/saved_posts"
                            element={
                              <RouteProtector
                                allowedRoles={["c"]}
                                redirectPath="/landing"
                              >
                                <SavedPosts />
                              </RouteProtector>
                            }
                          />
                          <Route
                            path="/post_applied"
                            element={
                              <RouteProtector
                                allowedRoles={["c"]}
                                redirectPath="/landing"
                              >
                                <PostsApplied />
                              </RouteProtector>
                            }
                          />
                          {/* <Route path="/joincaravan" element={<CandidateDashboard />} /> */}
                          <Route
                            path="/carnival/:carnivalId"
                            element={<CandidateDashboard />}
                          />

                          <Route path="/addpost" element={<AddPost />} />
                          <Route path="/viewjob/:postid" element={<ViewJob />} />
                          <Route path="/applyjob" element={<ApplyJob />} />
                          <Route
                            path="/candidature-spontanee/:companyName"
                            element={<ApplicationFormSp />}
                          />
                          <Route
                            path="/applications"
                            element={
                              <RouteProtector
                                allowedRoles={["r"]}
                                redirectPath="/landing"
                              >
                                <ApplicationsList />
                              </RouteProtector>
                            }
                          />
                          <Route
                            path="/talent/*"
                            element={
                              <RouteProtector
                                allowedRoles={["r"]}
                                redirectPath="/landing"
                              >
                                <AdminLayout />
                              </RouteProtector>
                            }
                          />
                          <Route
                            path="/manager/*"
                            element={
                              <RouteProtector
                                allowedRoles={["a"]}
                                redirectPath="/landing"
                              >
                                <AdminA />
                              </RouteProtector>
                            }
                          >
                            <Route
                              path="form_customizer"
                              element={<FormCustomizer />}
                            />
                            <Route
                              path="createRecruiter"
                              element={<CreateRecruiter />}
                            />
                            <Route path="ListRecruiter" element={<ListRecruiter />} />
                            <Route path="settings" element={<Settings />} />
                          </Route>
                          <Route
                            path="/superadmin/*"
                            element={
                              <RouteProtector
                                allowedRoles={["s"]}
                                redirectPath="/landing"
                              >
                                <SuperAdminLayout />
                              </RouteProtector>
                            }
                          />
                          <Route path="*" element={<ModernNotFound />} />
                        </Routes>
                      </SavedPostsProvider>
                    </SnackbarProvider>
                  </NotificationProvider>
                </TourProvider>
              </BrowserRouter>
            </CallersIdProvider>
          </VideoCallProvider>
        </SocketProvider>
      </Provider>
    </I18nextProvider>
  );
};

export default AppWrapper;